import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetContentContainerStyle0 = gravityIconIndividualCss;

const GravityIconAssetContentContainer = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'd239cb236a2d658aca1bf194b86fe441b9cd8a98', color: this.color, size: this.size }, h("svg", { key: '22505ce18c90583c06bc55203f9b42a9c0f41d95', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '66802b4952ab9d437820650a3873c011d5dc3842', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.5 2h15c.276 0 .5.241.5.538v16.924c0 .297-.224.538-.5.538h-15c-.276 0-.5-.241-.5-.538V2.538C3 2.241 3.224 2 3.5 2Zm14 16.5v-15h-13v15h13Z", fill: "currentColor" }), h("path", { key: '4b380c5c7833ad9bea3b604af1cdbc3d8dc9cdd9', d: "M6.5 7.75a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-9Zm0 3.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-9Z", fill: "currentColor" }))));
    }
};
GravityIconAssetContentContainer.style = GravityIconAssetContentContainerStyle0;

export { GravityIconAssetContentContainer as gravity_icon_asset_content_container };

//# sourceMappingURL=gravity-icon-asset-content-container.entry.js.map